import { RequestCareProgramResponse } from 'services/careProgramRequestService';
import { parseLocalDateString } from 'utils';
import { CareProgramRequestStatus } from '../types';
import { WELCOME_SHEET_BOUNDARY_WINDOW_DAYS } from '../constants';

export const isUnseen = (request: RequestCareProgramResponse): boolean =>
  request.member_notified_at === null;

/** Follows logic in:
 * https://lucid.app/lucidchart/688fd675-72b2-45fa-b477-2fda259a37ed/edit?invitationId=inv_57462ee3
 * -ed72-448a-97e9-9d691543d2b9&page=0_0# */
export const hasProgramStarted = (startDate: string): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = parseLocalDateString(startDate);

  const startDateBoundary = new Date(today);
  startDateBoundary.setDate(startDateBoundary.getDate() - WELCOME_SHEET_BOUNDARY_WINDOW_DAYS);

  return start <= today && start >= startDateBoundary;
};

export const isPendingWelcome = (request: RequestCareProgramResponse): boolean => {
  const subscription = request.care_program_subscription;
  return (
    request.status === CareProgramRequestStatus.APPROVED &&
    request.member_notified_at === null &&
    subscription !== null &&
    !subscription.is_ended &&
    hasProgramStarted(subscription.start_date)
  );
};
